import { reactive, toRaw } from 'vue'
import extent from 'geojson-extent';
import geoJson from "../../assets/churchesA.json";
import geoJsonB from "../../assets/churchesB.json";
import geoJsonC from "../../assets/churchesC.json";
import countriesData from "@/assets/CountryState.json"; //replace countriesData to countriesDataB
import countriesDataB from "@/assets/CountryStateB.json";
import countriesDataC from "@/assets/CountryStateC.json"; // may be need to replace this 
// import geoJson from "../../assets"

const state = { 
    isMobile: null,
    projIds: null,
    modernplace:null,

    dist:null,
    state:null,
    country:null,
    secular:null,
    bishop:null,
    archbishop:null,
    churchname:null,
    typesharing:null,
    congregat:null,
    sharing:null,
    protestant:null,
    sharingst:null,
    sharingend:null,
    groupin:null,
    dateStarted: null,
    dateEndedL: null,

    eStartDate: null,
    eEndDate: null,

    parishSaint: null,
    rGroups: null,
    locationType: null,

    secularFilter: false,
    cAJSON: null,
    View: null,
    map: null,
    selectedFeatures: null,

    countriesStateFile: countriesData,
    chbEsriTiles: false,
    chbPolitical: false,
    chbEcc: false,

    isDrawerOpen: false,
    drawerContent: null,

    churchesA: true,
    churchesB: false,
    churchesC: false,

    selectedLayer: "churchesA",
    layerOptions: [
        { value: 'churchesA', label: 'Shared Churches', disable:false },
        { value: 'churchesB', label: 'New Churches Num. 1', disable:false },
        { value: 'churchesC', label: 'New Churches Num. 2', disable:false },
      ],

    disabledOptions: {
        churchesA: false,
        churchesB: false,
        churchesC: false
    }
};
const getters = { 
    getIsMobile: (state) => state.isMobile,
    getView: (state) => state.View,

    getMap: (state) => state.map,


    getModernplace: (state) => state.modernplace,
    getDist: (state) => state.dist,
    getState: (state) => state.state,
    getCountry: (state) => state.country,
    getSecular: (state) => state.secular,
    getBishop: (state) => state.bishop,
    getArchbishop: (state) => state.archbishop,
    getChurchname: (state) => state.churchname,
    getTypesharing: (state) => state.typesharing,
    getCongregat: (state) => state.congregat,
    getSharing: (state) => state.sharing,
    getProtestant: (state) => state.protestant,
    getSharingst: (state) => state.sharingst,
    getSharingend: (state) => state.sharingend,
    getGroupin: (state) => state.groupin,

    getLocationtype: (state) => state.locationType,
    getRGroups: (state) => state.rGroups,
    getParishSaint: (state) => state.parishSaint,

    // getDateStarted: (state) => state.dateStarted,
    // getDateEnded: (state) => state.dateEnded,

    getChb0: (state) => state.chbEsriTiles,
    getChb1: (state) => state.chbPolitical,
    getChb2: (state) => state.chbEcc,

    getChb3: (state) => state.churchesA,
    getChb4: (state) => state.churchesB,
    getChb5: (state) => state.churchesC,

    getLayerOptions: (state) => state.layerOptions,
    getSelectedLayer: (state) => state.selectedLayer,
    getCountriesStateFile: (state) => state.countriesStateFile,
    getIsDrawerOpen: (state) => state.isDrawerOpen,
    getDrawerContent: (state) => state.drawerContent,
};

const mutations = { 
    SET_IS_MOB: (state, tabName) => {
        state.isMobile = tabName;
    },
    SET_VIEW: (state, payload) => {
        state.view = payload;
        console.log("state view:: ", state.View)
    },

    SET_MAP: (state, payload) => {
        state.map = payload;
    },

    SET_PROJIDS: (state, payload) => {
        state.projIds = toRaw(payload);        
    },
    

    SET_MODERNPLACE: (state, payload) => {
        state.modernplace = toRaw(payload);        
    },

    SET_DIST: (state, payload) => {
        state.dist = toRaw(payload);        
    },

    SET_STATE: (state, payload) => {
        state.state = toRaw(payload);        
    },

    SET_COUNTRY: (state, payload) => {
        state.country = toRaw(payload);        
        console.log("Country:: ",state.country)
    },

    SET_SECULAR: (state, payload) => {
        console.log("Set Seculart::", payload)
        state.secular = toRaw(payload);        
    },

    SET_SECULAR_FLTR: (state, payload) => {
        state.secularFilter = toRaw(payload);        
    },
    

    SET_BISHOP: (state, payload) => {
        state.bishop = toRaw(payload);        
    },

    SET_ARCHBISHOP: (state, payload) => {
        state.archbishop = toRaw(payload);        
    },

    SET_CHURCHNAME: (state, payload) => {
        state.churchname = toRaw(payload);        
    },

    SET_TYPESHARING: (state, payload) => {
        state.typesharing = toRaw(payload);        
    },

    SET_CONGREGAT: (state, payload) => {
        state.congregat = toRaw(payload);        
    },

    SET_SHARING: (state, payload) => {
        state.sharing = toRaw(payload);        
       },

    SET_PROTESTANT: (state, payload) => {
        state.protestant = toRaw(payload);        
    },

    SET_SHARINGST: (state, payload) => {
        state.sharingst = toRaw(payload);        
    },

    SET_SHARINGEND: (state, payload) => {
        state.sharingend = toRaw(payload);        
    },

    SET_LOC_TYPE: (state, payload) => {
        state.locationType = toRaw(payload);        
    },

    SET_RGROUPS: (state, payload) => {
        state.rGroups = toRaw(payload);        
    },

    SET_PARISH_SAINT: (state, payload) => {
        state.parishSaint = toRaw(payload);        
    },


    SET_GROUPIN: (state, payload) => {
        state.groupin = toRaw(payload);        
    },
    
    SET_COUNTRYSTATEFILE: (state, payload) => {
        state.countriesStateFile = toRaw(payload);        
    },
    

    SET_CHAJSON: (state, payload) => {
        state.cAJSON = payload;
        console.log("state map:: ", state.cAJSON)
    },
    
    SET_LYR0: (state, payload) => {
        state.chbEsriTiles = payload;
    },
    
    SET_LYR1: (state, payload) => {
        state.chbPolitical = payload;
    },

    SET_LYR2: (state, payload) => {
        state.chbEcc = payload;
    },


    SET_LYR3: (state, payload) => {
        state.churchesA = payload;
    },

    SET_LYR4: (state, payload) => {
        state.churchesB = payload;
    },

    SET_LYR5: (state, payload) => {
        state.churchesC = payload;
    },

    // SET_DATE_ST: (state, payload) => {
    //     state.dateStarted = payload;
    // },

    // SET_DATE_END: (state, payload) => {
    //     state.dateEnded = payload;
    // },

    SET_LAYER(state, layer) {
        state.selectedLayer = layer;
        if(layer == 'churchesA'){
            console.log("Countries in Set Layer countriesData:: ", countriesData)
            state.countriesStateFile = countriesData
        } else if (layer ==  'churchesB') {
            state.countriesStateFile = countriesDataB
        } else if (layer ==  'churchesC') {
            state.countriesStateFile = countriesDataC
        }   
        // this.extractProjIds(); // run the function to refresh the drop downs 
        console.log("selected Layer is ::",layer)
      },

      SET_LAYER_PROG(state, layer) {
        state.selectedLayer = layer;
      },

      SET_DRAWER(state, payload) {
        console.log("set drawer::", payload)
        state.isDrawerOpen = payload.isOpen;
        state.drawerContent = payload.payload;
        console.log("consnt::", state.drawerContent)
      },

      SET_E_STARTDATE(state, payload) { 
        state.eStartDate = payload
      },

      SET_E_ENDDATE(state, payload) { 
        state.eEndDate = payload
      },
      
    //   setLayerOptions(state, updatedOptions) {
    //     state.layerOptions = updatedOptions;
    //   },

      setLayerDisable(state, { value, disable }) {
        const layer = state.layerOptions.find(option => option.value === value);
        if (layer) {
          layer.disable = disable;
        }
      },
    

      setCheckboxDisabledStatus(state, disabledOptions) {
        state.disabledOptions = disabledOptions;  // Store checkbox enabled/disabled status
      }
};
const actions = {

    // filterGeojson({ dispatch }, event) {
        
    //     console.log("filter gejson", event)
    //     if(event !== null){
    //         state.map.setFilter('churchesA', ['==', ['get', 'Modern Placename'], event]);
    //         if(event.length > 1){
    //             console.log("Event:: ", event)
    //             // dispatch('getFilterFeatures',event)
    //         }
    //     }
    //   },


      filterGeojson({ state, dispatch, commit },   data) {
        let gJ = geoJson
        if(state.selectedLayer == 'churchesB'){
            gJ = geoJsonB
        } else if(state.selectedLayer == 'churchesC'){
            gJ = geoJsonC
        }

        let event = data[0]
        let filterProperty = data[1]
        // console.log("filter gejson", data, event,   filterProperty, " --- ", state.selectedLayer);
        console.log("filter gejson Event::", event," Filtered Prodde",   filterProperty, " --- ", state.selectedLayer);
        
        // dispatch('resetMap')
        // if (event !== null) {

        let filteredFeatures

            if(filterProperty == 'Early Modern Secular Ruler (Jurisdiction / Herrschaft)') {
                if (event === null) {                    
                    // console.log("Display all features when clear clicked...",gJ.features)
                    filteredFeatures = gJ.features;
                    // console.log("1. filteredFeatures::", filteredFeatures)
                    commit('SET_SECULAR_FLTR', false) // This will clear that filter happend 
                //    filteredFeatures = dispatch('clearSecJurFltr',gJ)
                
                } else {
                 commit('SET_SECULAR_FLTR', true) // This will indicate that filter happend             
                // state.map.setFilter(state.selectedLayer, ['<', ['get', filterProperty], event]);
                   
               
                 // Apply the filter based on the text input
                    // map.setFilter(state.selectedLayer, [ "any", [ ">=", ["indexOf", event, ["downcase", ["get", filterProperty]]], 0 ] ]);

                    const searchText = event.toLowerCase();
                    console.log("inside the Event searchText::",searchText)
                    console.log("geoJson::",gJ)

                     filteredFeatures = gJ.features.filter(feature => {
                        const propertyValue = feature.properties[filterProperty];
                        console.log("Checking feature property:", propertyValue);
                        if (propertyValue && propertyValue.toLowerCase().includes(searchText)) {
                            console.log("Match found:", propertyValue);
                            return true;
                        }
                        return false;
                    });

                    // // Filter GeoJSON features manually
                    //  filteredFeatures = gJ.features.filter(feature => {
                    //     // console.log(feature.properties[filterProperty].toLowerCase())
                    //     return feature.properties[filterProperty].toLowerCase().includes(searchText);
                    // });

                    }   

                    console.log("filteredFeatures::", filteredFeatures)

                    // Update the map source with filtered data
                    state.map.getSource(state.selectedLayer).setData({
                        type: "FeatureCollection",
                        features: filteredFeatures
                    });
                // }
            } else if(filterProperty.includes('Date sharing Started (de facto)') || filterProperty == 'Date sharing Ended (de facto)' ) { 
                console.log("inseide the date property...")
                if(filterProperty == 'Date sharing Started (de facto)'){
                     commit('SET_E_STARTDATE',event)
                     console.log("in the IF", state.eStartDate )
                    }
                    else {
                        commit('SET_E_ENDDATE',event)
                        console.log("in the Else")
                    } 
                // >>> Fix the section below --- Check the this.sharingStarted  this.sharingEnded in the 
               // Filter GeoJSON features
              // Filter GeoJSON features
              const filteredFeatures = gJ.features.filter(feature => {
                let startDate = feature.properties['Date sharing Started (de facto)'];
                let endDate = feature.properties['Date sharing Ended (de facto)'];
            
                // Convert values to numbers and handle missing values
                startDate = startDate ? parseInt(startDate, 10) : null;
                endDate = endDate ? parseInt(endDate, 10) : null;
            
                // Ensure state values are numbers
                const eStartDate = state.eStartDate ? parseInt(state.eStartDate, 10) : null;
                const eEndDate = state.eEndDate ? parseInt(state.eEndDate, 10) : null;
            
                // Case 1: Both eStartDate and eEndDate are provided
                if (eStartDate !== null && eEndDate !== null) {
                    // console.log(`Checking feature: Start = ${startDate}, End = ${endDate}`);
                    // console.log(`Checking feature: Start = ${startDate}, End = ${endDate} Selection Range: eStartDate = ${eStartDate}, eEndDate = ${eEndDate}`);
            
                    // Check conditions
                    const startCondition = startDate >= eStartDate  && startDate <= eEndDate;
                    const endCondition = endDate >= eStartDate  && endDate <= eEndDate;
            
                    if (startDate !== null && endDate !== null && startCondition && endCondition) {
                        // console.log("✅ Selection meets ",` ${startDate}  ${endDate} `);
                        return true;
                    } else {
                        // console.log("❌ Selection does NOT meet.",` ${startDate} ${endDate} start Cond ${startCondition} end Cond ${endCondition} startDate <= eStartDate == ${startDate <= eStartDate}`);
                        return false;
                    }
                }
                // Case 2: Only eStartDate is provided (Get all churches from this year onward)
                else if (eStartDate !== null) {
                    console.log("Second IF: Filtering from", eStartDate, "onwards");
                    return (startDate !== null && startDate >= eStartDate);
                }
                // Case 3: Only eEndDate is provided (Get all churches up to this year)
                else if (eEndDate !== null) {
                    console.log("Third IF: Filtering up to", eEndDate);
                    return (endDate !== null && endDate <= eEndDate);
                }
                // Case 4: No filters applied, return all churches
                else {
                    console.log("Fourth IF: No filters, returning all churches");
                    return true;
                }
            });
            
                console.log(filteredFeatures);

                // Update the map source with filtered data
                state.map.getSource(state.selectedLayer).setData({
                    type: "FeatureCollection",
                    features: filteredFeatures
                });
            }
            else {
                if(state.secularFilter){
                    console.log("Sec Jur Filter:: ", state.secularFilter)
                    console.log("1. filteredFeatures::", filteredFeatures)
                    filteredFeatures = gJ.features;  
                    state.map.getSource(state.selectedLayer).setData({
                        type: "FeatureCollection",
                        features: filteredFeatures
                    });          
                    commit('SET_SECULAR_FLTR', false)
                }                
                state.map.setFilter(state.selectedLayer, ['==', ['get', filterProperty], event]);
            }
          
        //   if (event.length > 1) {
        //     console.log("Event:: ", event);
        //     // dispatch('getFilterFeatures', event);
        //   }
        // }
      },


      
      filterGeojsonStandBy({ state }, data) {
        let searchTerm = data[0].toLowerCase(); // Convert search term to lowercase for case-insensitive match
        let filterProperty = data[1];
        
        console.log("Filter GeoJSON with contains", data, searchTerm, filterProperty);
        
        if (searchTerm !== null && searchTerm.length > 0) {
            // Use 'in' to check if the search term exists within the filter property
            state.map.setFilter(state.selectedLayer, [
            'in',
            searchTerm,
            ['downcase', ['get', filterProperty]] // Convert the property value to lowercase
            ]);
            
            console.log("Filtered with searchTerm: ", searchTerm);
        }
      },


      getFilterFeatures({state},e){
         /// Get all rendered features after applying the filter
        const allFeatures = toRaw(state.cAJSON.features)
         // Filter the features based on your original criteria
         const filteredFeatures = allFeatures.filter(feature => feature.properties['Modern Placename'] === e); // Adjust the filter condition as needed
 
          // Array containing the features matching your criteria

        
        const ffJSON = {type: 'FeatureCollection', features: filteredFeatures}
        //  console.log("ffJSON::",ffJSON);
        console.log("filteredFeatures::",filteredFeatures);

        const bounds = extent(ffJSON);
            
        console.log(bounds[0] , bounds[2] , bounds[1] , bounds[3])    
        // Calculate center coordinates manually
        const centerLongitude = (bounds[0] + bounds[2]) / 2;
        const centerLatitude = (bounds[1] + bounds[3]) / 2;

        const centerCoordinates = [centerLongitude, centerLatitude];

        console.log("bounds:: ", bounds, " bounds.center", centerCoordinates)

        state.map.flyTo({
            center: centerCoordinates, // Center of the bounding box
            zoom: 6, // Set a desired zoom level (adjust as needed)
            essential: true, // Ensures animation completes even if map container is not in view
            speed: 2 // Adjust animation speed (optional)
            });

      },

      addLayer({commit},lyrId){
        // Update layerOptions based on visibility of churchesA and churchesB
                // console.log("Add Layer:: ", isVisible, "  lyrId::",lyrId , " visibility:: ",state.map.getLayoutProperty(lyrId, 'visibility'))
                console.log("Add Layer:: ",lyrId )
                // If condition below handles the undefined statues of churches layer when they start
                if (state.map.getLayoutProperty(lyrId, 'visibility') == undefined) {
                    state.map.setLayoutProperty(lyrId, 'visibility', 'visible')
                } 
                    
                const isVisible = state.map.getLayoutProperty(lyrId, 'visibility') === 'visible';
                state.map.setLayoutProperty(lyrId, 'visibility', isVisible ? 'none' : 'visible');


                // Update layerOptions and disable/enable checkboxes based on visibility
        let updatedOptions = [];
        let disabledOptions = {
            churchesA: false,
            churchesB: false,
            churchesC: false,
        };

        // Check the visibility of churchesA and churchesB and update options accordingly
        const churchesAVisible = state.map.getLayoutProperty('churchesA', 'visibility') === 'visible';
        const churchesBVisible = state.map.getLayoutProperty('churchesB', 'visibility') === 'visible';
        const churchesCVisible = state.map.getLayoutProperty('churchesC', 'visibility') === 'visible';

        if (lyrId == 'churchesA') { 
            if (!churchesAVisible) {
                commit('setLayerDisable', { value: 'churchesA', disable: true });
            } else {
                commit('setLayerDisable', { value: 'churchesA', disable: false });
                state.map.setFilter('churchesA', null);  // Remove existing filters on layer
            }
        }
        
        if (lyrId == 'churchesB') { 
            if (!churchesBVisible) {
                commit('setLayerDisable', { value: 'churchesB', disable: true });
            } else {
                commit('setLayerDisable', { value: 'churchesB', disable: false });
                state.map.setFilter('churchesB', null);
            }
        }
        
        if (lyrId == 'churchesC') { 
            if (!churchesCVisible) {
                commit('setLayerDisable', { value: 'churchesC', disable: true });
            } else {
                commit('setLayerDisable', { value: 'churchesC', disable: false });
                state.map.setFilter('churchesC', null);
            }
        }

        // if(churchesAVisible && !churchesBVisible)
        //     {
        //         commit('SET_LAYER', 'churchesA')
        //     }
        // else if (!churchesAVisible && churchesBVisible)
        //     {
        //         commit('SET_LAYER', 'churchesB')
        //     }
        
        // Adjust logic to handle combinations of visible layers
        if (churchesAVisible && !churchesBVisible && !churchesCVisible) {
            commit('SET_LAYER', 'churchesA');
        } else if (!churchesAVisible && churchesBVisible && !churchesCVisible) {
            commit('SET_LAYER', 'churchesB');
        } else if (!churchesAVisible && !churchesBVisible && churchesCVisible) {
            commit('SET_LAYER', 'churchesC');
        } 
        
        // else if (churchesAVisible && churchesBVisible && !churchesCVisible) {
        //     commit('SET_LAYER', 'churchesA and churchesB');
        // } else if (churchesAVisible && !churchesBVisible && churchesCVisible) {
        //     commit('SET_LAYER', 'churchesA and churchesC');
        // } else if (!churchesAVisible && churchesBVisible && churchesCVisible) {
        //     commit('SET_LAYER', 'churchesB and churchesC');
        // } else if (churchesAVisible && churchesBVisible && churchesCVisible) {
        //     commit('SET_LAYER', 'churchesA, churchesB, and churchesC');
        // }

        // Commit the updated layer options and disable/enable status to Vuex
        
        // commit('setLayerOptions', updatedOptions);
        // commit('setCheckboxDisabledStatus', disabledOptions);
      },

      resetMap({  },) {
        console.log("inside the reset map...")
        // let gJ = geoJson
        // if(state.selectedLayer == 'churchesB'){
        //     gJ = geoJsonB
        // }
        state.map.setFilter(state.selectedLayer, null)
      },

      openDrawer({commit, state},payload){
        console.log("open Drawer:: ",payload)
        commit('SET_DRAWER', { isOpen: true, payload });
      },

      closeDrawer({ commit }) {
        console.log("close Drawer::")
        commit('SET_DRAWER', { isOpen: false, payload: null });
      },

      applyFilter ({}) {
        // dates = store.getters["getSharingst"]
        const selectedDate = dates[sliderValue.value];
        map.value.setFilter("data-layer", ["==", ["get", "date"], selectedDate]);
      },
      
      extractProjIds({commit, state}) {
        let gJ = geoJson
        if(state.selectedLayer == 'churchesB'){
            gJ = geoJsonB
        } else if(state.selectedLayer == 'churchesC'){
            gJ = geoJsonC
        }
       let  projectIds = [ ...new Set(gJ.features.map((feature) => feature.properties["Project Object ID"])), ];
        commit('SET_PROJIDS',projectIds)
      
      
        //ToDo:: when chcurches B is selected Update this definition with respect to geoJsonB
        // MOve this function in the store and take parameters for extraProjectIds either geoJSON of geoJSONB
        
      
        const modernPlacename = [ ...new Set( gJ.features.map((feature) => feature.properties["Modern Placename"]) ),];
        // console.log("gj::", gJ, " modernPlacename:", modernPlacename)
        // const district = [ ...new Set( gJ.features.map((feature) => feature.properties["Modern District/County (Landeskreis/Bezirk"]) ),];
        const district = [ ...new Set( gJ.features.map((feature) => feature.properties["Modern District/County (Landeskreis/Bezirk"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        
        const state_ = [ ...new Set( gJ.features.map((feature) => feature.properties["Modern State (Bundesland/Département/Canton)"]) ),];
        const country = [
            ...new Set(
              gJ.features
                .map((feature) => feature.properties["Modern Country"])
                .filter(Boolean) // Remove any falsy values like null, undefined, or empty strings
            )
          ].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
          
        //   console.log(country);
          
        // const secularJuris = [
        //     ...new Set(
        //       gJ.features
        //         .map((feature) => feature.properties["Secular Jurisdiction"])
        //         .filter(Boolean) // Remove any falsy values
        //     )
        //   ].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));

        //   const secularJuris = ["Aachen (imperial city)", "Aargau (district)", "Aarwangen (lordship)"]

        
        // const secularJuris = [ "Aargau (canton)","Alpirmont (lordship)","Amelunxen (lordship)","Andlau (lordship)","Appenzell (canton)","Asburg (lordship)","Aschaffenburg (principality)","Augsburg (imperial city)","Austria (archduchy, empire)","Austria (empire)","Bächingen (lordship)","Baden (electors, grand duchy)","Baden (grand duchy)","Baden (margraviate)","Baden [Swiss] (county)","Baden-Baden (margraviate)","Baden-Durlach (margraviate)","Bamberg (bishopric)","Bavaria (elector, kingdom)","Bavaria (kingdom)","Bayreuth (margraviate)","Bentheim (county)","Bentheim-Limburg (county)","Bentheim-Tecklenburg-Rheda (county)","Berckheim (lordship)","Berg (county, duchy)","Berg (duchy)","Berg (grand duchy)","Bern/Fribourg (common lordship)","Berrstet (lordship)","Bettendorﬀ (baronry)","Biberach an der Riß (imperial city)","Block (lordship)","Blumencron (lordship)","Böcklin von Böcklinsau (lordship)","Bohemia (kingdom)","Bolanden (lordship)","Boos von Waldeck (lordship)","Bourscheid-Burgbrohl-Büllesheim (lordship)","Boxberg (lordship)","Brabant (duchy)","Brandenburg (electorate)","Brandenburg [-Prussia] (margraviate, electorate, kingdom)","Brandenburg Teil:","Brandenburg-Ansbach (margraviate)","Brandenburg-Kulmbach (margraviate)","Braunsberg-Burgbrohl (lordship)","Breitenstein (lordship)","Bremen (bishopric)","Bretzenheim (lordship)","Brunswick-Lüneburg (duchy)","Brunswick-Wolfenbüttel (duchy)","Bubenhofen (lordship)","Burgau (margraviate)","Bürglen (lordship)","Bussnang (lordship)","Chur (bishopric)","Cleves (duchy)","Cologne (archbishopric, electorate)","Condominium","Constance (bishopric)","Constance (imperial city)","Corvey (abbacy)","Cosswiller (lordship)","Crailsheim (lordship)","Dahl (lordship)","Dahlem (county)","Dalberg (lordship)","Degenfeld (lordship)","Denmark (kingdom)","Dettlingen (lordship)","Dienheim (lordship)","Diessenhofen (imperial city)","Durckheim (lordship)","Eckwersheim (lordship)","Ehrenberg (lordship)","Elz (county)","Eppstein (lordship)","Eppstein-Königstein (lordship)","Erstein (abbacy)","Etzbach (lordship)","Falkenstein (county)","Faust zu Stromberg (lordship)","Fick zu Ammerthal (lordship)","Finstingen (lordship)","Fischingen (abbacy)","Flanders (county)","Fleckenstein (lordship)","Flersheim (lordship)","Forstmeister von Gelnhausen (lordship)","France (empire)","France (kingdom, republic, empire)","France (kingdom)","France (republic, empire)","Frankenstein (county)","Frankfurt (grand duchy)","Frankfurt am Main (imperial city)","Freudenberg (lordship)","Fuchs von Bimbach (lordship)","Fuchs von Dornheim (barony)","Fugger von der Lilie (county)","Fürstenau (district)","Fürstenberg (lordship)","Gemen (lordship)","Gemmingen (lordship)","Gemmingen-Hornberg (lordship)","Geroldseck (lordship)","Giel von Glattburg (bailiwick)","Glarus (imperial valley)","Glaubitz (lordship)","Göler von Ravensburg (lordship)","Griesenberg (lordship)","Grostein (lordship)","Grumbach (Wald- and Rhinegraviate)","Habsburg (archduchy)","Habsburg (empire)","Hanau (county)","Hanau-Lichtenberg (county)","Hanau-Münzenberg (county)","Hanover (kingdom)","Hardenberg (lordship)","Hardheim (lordship)","Hatzfeld (county)","Haune (lordship)","Helfenstein (lordship)","Helmstatt (lordship)","Henneberg (county)","Herdecke (district / Freiheit)","Herford (imperial city)","Hesse (grand duchy)","Hesse (landgraviate)","Hesse-Darmstadt (grand duchy)","Hesse-Darmstadt (landgraviate)","Hesse-Homburg (landgraviate)","Hesse-Kassel (landgraviate)","Hesse-Marburg (landgraviate)","Hesse-Rheinfals (princely landgraviate)","Hildesheim (bishopric)","Hintere Sponheim (county)","Hirschberg (lordship)","Hirstfeld (lordship)","Hochgericht Vier Dörfer (district)","Hohenbourg (lordship)","Hohenlohe-Neuenstein-Neuenstein (county)","Hohenlöhe-Schillingfürst (county)","Hohenlohe-Waldenburg-Bartenstein (principality)","Hohenlohe-Waldenburg-Waldenburg (principality)","Holland (county)","Hundt (lordship)","Hunolstein-Steinkallenfels (lordship)","Hutten (lordship)","Ingelheim (county)","Isenburg-Büdingen (county)","Ittingen (abbacy)","Joint holding [Ganerbenschaft]","Kaltental (lordship)","Kanne (lordship)","Katzenelnbogen (county)","Kaufbeuren (imperial city)","Kempten (abbacy)","Klingenberg (lordship)","Knöringen (lordship)","Koppenstein (lordship)","Kratz von Scharfenstein (lordship)","Kreuzlingen (abbacy)","Krnov (duchy)","Kronberg (lordship)","Kyrburg (wildgraviate)","Landau (imperial city)","Landenberg-Greifensee (lordship)","Leiningen (county)","Leiningen-Dagsburg-Hardenburg (county)","Leiningen-Heidesheim (county)","Leiningen-Oberborn (county)","Leiningen-Westerburg (county)","Leiningen-Westerburg-Rixingen (county)","Léman (canton)","Leyen (lordship)","Lichtenberg (lordship)","Liebburg (lordship)","Liège (bishopric)","Limburg (county)","Limburg-Styrum (lordship)","Lindenfels (lordship)","Lingen (county)","Lobkowitz (duchy)","Lorch (abbacy)","Lorraine (duchy)","Löwenhaupt (lordship)","Löwenstein (lordship)","Löwenstein-Wertheim (county)","Lüchau (lordship)","Lumersheim (lordship)","Lüttwitz (lordship)","Magdeburg (prince-archbishop)","Mahlberg (lordship)","Mainz (archbishopric, electorate)","Maldeghem (county)","Mansfeld (county)","Mark (county)","Martinstein (lordship)","Mauchenheim genannt Bechtolsheim (lordship)","Memmingen (imperial city)","Metternich (lordship)","Metzenhausen (lordship)","Meuron (lordship)","Michaelsberg (abbacy)","Moers (county)","Montbéliard (principality)","Montfort (county)","Montgomery (county)","Mühlhausen (imperial city)","Münch (lordship)","Munich (imperial city)","Nassau (duchy)","Neckarsteinach (lordship)","Neuburg (principality)","Neuchâtel (principality)","Niederaspach (lordship)","Nürtingen (imperial city)","Nuremberg (imperial city)","Oberammergau (abbacy)","Oberhausen (lordship)","Oldenburg (county, duchy)","Österreich (Austria)","Oettingen-Baldern (county)","Oettingen-Wallerstein (county)","Ortenberg (lordship)","Palatinate-Neuburg (county)","Palatinate-Simmern (county)","Petershausen (abbacy)","Pforzheim (imperial city)","Pforzen (lordship)","Pfuhl (lordship)","Prague (kingdom)","Prussia (kingdom)","Prussia (state)","Püchler von Püchlberg (lordship)","Questenberg (lordship)","Radbruch (lordship)","Rappenstein (lordship)","Ravensburg (imperial city)","Rechtenstein (lordship)","Regensburg (bishopric)","Regensburg (imperial city)","Reichenau (abbacy)","Reisen (lordship)","Reuß (principality)","Reutte (district)","Rhine Confederation","Rhinegrave (county)","Rhineland (district)","Rhineland-Palatinate (state)","Richlingen (lordship)","Rohrbach (lordship)","Rosenberg (lordship)","Rothenburg ob der Tauber (imperial city)","Rüdesheim (imperial city)","Rügen (county)","Salem (abbacy)","Salzburg (archbishopric)","Sargans (imperial valley)","Schaumburg (county)","Schernau (lordship)","Schleswig-Holstein (county)","Schmidburg (lordship)","Schönborn (principality)","Schwaben (Swabia)","Schweidnitz-Jauer (duchy)","Schweinfurt (imperial city)","Schwendi (lordship)","Seckendorff (lordship)","Seedorf (abbacy)","Selz (imperial city)","Sickingen (lordship)","Siggenhausen (lordship)","Sigmaringen (principality)","Silesia (duchy)","Singen (lordship)","Solothurn (canton)","Solothurn (lordship)","Solms (county)","Solms-Braunfels (county)","Solms-Hohensolms-Lich (county)","Solms-Laubach (county)","Solms-Rödelheim-Assenheim (county)","Solothurn (canton)","Sonnenberg (county)","Sonnefeld (abbacy)","Speyer (bishopric)","St. Blasien (abbacy)","St. Gallen (imperial abbey)","Stein am Rhein (imperial city)","Steinbrück (lordship)","Steinfurt (county)","Stolberg (county)","Stuttgart (lordship)","Sulz (county)","Sundgau (district)","Swabia (duchy)","Switzerland (confederacy)","Tecklenburg (county)","Thann (imperial city)","Theismann (lordship)","Thun (canton)","Thuringia (landgraviate)","Tirol (county)","Trechsel von Wertheim (lordship)","Trechtingshausen (lordship)","Trier (archbishopric, electorate)","Truchseß von Wetzhausen (lordship)","Türkheim (county)","Tuttlingen (lordship)","Ulm (imperial city)","Unterboihingen (lordship)","Unterwalden (imperial city)","Urach (imperial city)","Urseren (imperial valley)","Varenne (district)","Vaud (canton)","Vechelde (lordship)","Veitsberg (abbacy)","Veltheim (lordship)","Verden (bishopric)","Vienna (imperial city)","Visp (district)","Vogelsang (lordship)","Wädenswil (imperial city)","Wald (imperial city)","Waldeck (county)","Waldburg (county)","Waldburg-Trauchburg (county)","Waldkirch (imperial city)","Waldkirchen (lordship)","Walther von Waldenfels (lordship)","Wandelsheim (lordship)","Weilburg (county)","Weiler (lordship)","Weilheim (lordship)","Weinheim (lordship)","Weisenau (lordship)","Weissensee (abbacy)","Wertheim (county)","Wesel (imperial city)","Westerburg (county)","Wetter (district)","Wetterau (district)","Widdern (lordship)","Wildberg (county)","Wildgraben (lordship)","Windsheim (imperial city)","Württemberg (duchy, kingdom)","Zell am See (abbacy)","Zirndorf (lordship)","Zollern (county)","Zug (imperial city)","Zurich (imperial city)","Zurich (imperial city)"];
        
        const secularJuris = ["Aargau (canton)", "Alpirmont (lordship)", "Amelunxen (lordship)", "Andlau (lordship)", "Appenzell (canton)", "Asburg (lordship)", "Aschaffenburg (principality)", "Augsburg (imperial city)", "Austria (archduchy, empire)", "Austria (empire)", "Bächingen (lordship)", "Baden (electors, grand duchy)", "Baden (grand duchy)", "Baden (margraviate)", "Baden [Swiss] (county)", "Baden-Baden (margraviate)", "Baden-Durlach (margraviate)", "Bamberg (bishopric)", "Bavaria (elector, kingdom)", "Bavaria (kingdom)", "Bayreuth (margraviate)", "Bentheim (county)", "Bentheim-Limburg (county)", "Bentheim-Tecklenburg-Rheda (county)", "Berckheim (lordship)", "Berg (county, duchy )", "Berg (duchy)", "Berg (grand duchy)", "Bern/Fribourg (common lordship)", "Berrstet (lordship)", "Bettendorﬀ (baronry)", "Biberach an der Riß (imperial city)", "Block (lordship)", "Blumencron (lordship)", "Böcklin von Böcklinsau (lordship)", "Bohemia (kingdom)", "Bolanden (lordship)", "Boos von Waldeck (lordship)", "Bourscheid-Burgbrohl-Büllesheim (lordship)", "Boxberg (lordship)", "Brabant (duchy)", "Brandenburg (electorate)", "Brandenburg [-Prussia] (margraviate, electorate, kingdom)", "Brandenburg Teil:", "Brandenburg-Ansbach (margraviate)", "Brandenburg-Kulmbach (margraviate)", "Braunsberg-Burgbrohl (lordship)", "Breitenstein (lordship)", "Bremen (bishopric)", "Bretzenheim (lordship)", "Brunswick-Lüneburg (duchy)", "Brunswick-Wolfenbüttel (duchy)", "Bubenhofen (lordship)", "Burgau (margraviate)", "Bürglen (lordship)", "Bussnang (lordship)", "Chur (bishopric)", "Cleves (duchy)", "Cologne (archbishopric, electorate)", "Condominium", "Constance (bishopric)", "Constance (imperial city)", "Corvey (abbacy)", "Cosswiller (lordship)", "Crailsheim (lordship)", "Dahl (lordship)", "Dahlem (county)", "Dalberg (lordship)", "Degenfeld (lordship)", "Denmark (kingdom)", "Dettlingen (lordship)", "Dienheim (lordship)", "Diessenhofen (imperial city)", "Durckheim (lordship)", "Eckwersheim (lordship)", "Ehrenberg (lordship)", "Elz (county)", "Eppstein (lordship)", "Eppstein-Königstein (lordship)", "Erstein (abbacy)", "Etzbach (lordship)", "Falkenstein (county)", "Faust zu Stromberg (lordship)", "Fick zu Ammerthal (lordship)", "Finstingen (lordship)", "Fischingen (abbacy)", "Flanders (county)", "Fleckenstein (lordship)", "Flersheim (lordship)", "Forstmeister von Gelnhausen (lordship)", "France (empire)", "France (kingdom, republic, empire)", "France (kingdom)", "France (republic, empire)", "Frankenstein (county)", "Frankfurt (grand duchy)", "Frankfurt am Main (imperial city)", "Freudenberg (lordship)", "Fuchs von Bimbach (lordship)", "Fuchs von Dornheim (barony)", "Fugger von der Lilie (county)", "Fürstenau (district)", "Fürstenberg (lordship)", "Gemen (lordship)", "Gemmingen (lordship)", "Gemmingen-Hornberg (lordship)", "Geroldseck (lordship)", "Giel von Glattburg (bailiwick)", "Glarus (imperial valley)", "Glaubitz (lordship)", "Göler von Ravensburg (lordship)", "Griesenberg (lordship)", "Grostein (lordship)", "Grumbach (Wald- and Rhinegraviate)", "Habsburg (archduchy)", "Habsburg (empire)", "Hanau (county)", "Hanau-Lichtenberg (county)", "Hanau-Münzenberg (county)", "Hanover (kingdom)", "Hardenberg (lordship)", "Hardheim (lordship)", "Hatzfeld (county)", "Haune (lordship)", "Helfenstein (lordship)", "Helmstatt (lordship)", "Henneberg (county)", "Herdecke (district / Freiheit)", "Herford (imperial city)", "Hesse (grand duchy)", "Hesse (landgraviate)", "Hesse-Darmstadt (grand duchy)", "Hesse-Darmstadt (landgraviate)", "Hesse-Homburg (landgraviate)", "Hesse-Kassel (landgraviate)", "Hesse-Marburg (landgraviate)", "Hesse-Rheinfals (princely landgraviate)", "Hildesheim (bishopric)", "Hintere Sponheim (county)", "Hirschberg (lordship)", "Hirstfeld (lordship)", "Hochgericht Vier Dörfer (district)", "Hohenbourg (lordship)", "Hohenlohe-Neuenstein-Neuenstein (county)", "Hohenlöhe-Schillingfürst (county)", "Hohenlohe-Waldenburg-Bartenstein (principality)", "Hohenlohe-Waldenburg-Waldenburg (principality)", "Holland (county)", "Hundt (lordship)", "Hunolstein-Steinkallenfels (lordship)", "Hutten (lordship)", "Ingelheim (county)", "Isenburg-Büdingen (county)", "Ittingen (abbacy)", "Joint holding [Ganerbenschaft]", "Kaltental (lordship)", "Kanne (lordship)", "Katzenelnbogen (county)", "Kaufbeuren (imperial city)", "Kempten (abbacy)", "Klingenberg (lordship)", "Knöringen (lordship)", "Koppenstein (lordship)", "Kratz von Scharfenstein (lordship)", "Kreuzlingen (abbacy)", "Krnov (duchy)", "Kronberg (lordship)", "Kyrburg (wildgraviate)  1520-1750", "Landau (imperial city)", "Landenberg-Greifensee (lordship)", "Leiningen (county)", "Leiningen-Dagsburg-Hardenburg (county)", "Leiningen-Heidesheim (county)", "Leiningen-Oberborn (county)", "Leiningen-Westerburg (county)", "Leiningen-Westerburg-Rixingen (county)", "Léman (canton)", "Leyen (lordship)", "Lichtenberg (lordship)", "Liebburg (lordship)", "Liège (bishopric)", "Limburg (county)", "Limburg-Styrum (lordship)", "Lindenfels (lordship)", "Lingen (county)", "Lobkowitz (duchy)", "Lorch (abbacy)", "Lorraine (duchy)", "Löwenhaupt (lordship)", "Löwenstein (lordship)", "Löwenstein-Wertheim (county)", "Lüchau (lordship)", "Lumersheim (lordship)", "Lüttwitz (lordship)", "Magdeburg (prince-archbishop)", "Mahlberg (lordship)", "Mainz (archbishopric, electorate)", "Maldeghem (county)", "Mansfeld (county)", "Mark (county)", "Martinstein (lordship)", "Mauchenheim genannt Bechtolsheim (lordship)", "Memmingen (imperial city)", "Metternich (lordship)", "Metzenhausen (lordship)", "Moers (lordship)", "Moers-Saarwerden (county)", "Mueg (family)", "Münster (bishopric)", "Munster (imperial abbey)", "Münster (lordship)", "Muri (abbacy)", "Nassau (county)", "Nassau (duchy)", "Nassau-Dillengburg (county)", "Nassau-Saarbrücken (county, principality)", "Nassau-Saarbrücken (county)", "Nassau-Saarbrücken (principality)", "Nassau-Saarbrücken-Weilburg (county, principality)", "Nassau-Saarwerden (county)", "Nassau-Siegen (county, principality)", "Nassau-Usingen (principality)", "Nassau-Weilburg (county, principality)", "Nassau-Weilburg (county)", "Nassau-Weilburg (principality)", "Neipperg (lordship)", "Netherlands (kingdom)", "Neuburg-Sulzbach (duchy)", "Niesemeuschel (lordship)", "Notthaﬀt von Weissenstein (lordship)", "Nuremberg (burggraviate)", "Oberstein (imperial lordship)", "Ochsenstein (lordship)", "Oettingen-Oettingen (county, principality)", "Oldenburg (duchy)", "Oldenburg (grand dukes)", "Opole (duchy)", "Orange-Nassau (county, principality)", "Orange-Nassau (county)", "Osnabrück (bishopric)", "Ottweiler (lordship)", "Palatinate (electoral)", "Palatinate-Lautern (duchy)", "Palatinate-Mosbach (duchy)", "Palatinate-Neuburg (duchy, electorate)", "Palatinate-Neuburg (duchy)", "Palatinate-Simmern (duchy)", "Palatinate-Sulzbach (duchy)", "Palatinate-Veldenz (duchy)", "Palatinate-Veldenz-Lauterecken (duchy)", "Palatinate-Veldenz-Lützelstein (duchy)", "Palatinate-Zweibrücken (county, duchy)", "Palatinate-Zweibrücken-Birkenfeld (county, duchy)", "Palatinate-Zweibrücken-Kleeburg (duchy)", "Pappenheim (county)", "Parkstein-Weiden (barony)", "Partenheim (lordship)", "Poland (kingdom)", "Pölnitz (lordship)", "Pomerania (duchy)", "Pomerania-Stolp (duchy)", "Prussia (kingdom)", "Puller von Hohenburg (lordship)", "Quadt-Wickrath (lordship)", "Quitzow (lordship)", "Racibórz (duchy)", "Randeck (lordship)", "Rappoltstein (lordship, county)", "Rappoltstein (lordship)", "Ratshamhausen (lordship)", "Ravensberg (county)", "Rechberg (county)", "Redwitz (lordship)", "Reichenau (abbacy)", "Reichenweier (lordship)", "Reitzenstein (lordship)", "Rheda (lordship)", "Rheineck (county)", "Rheintal (bailiwick)", "Rhön-Werra (lordship)", "Riaucour (county)", "Ribeaupierre (lordship)", "Riedheim (lordship)", "Ringenberg (lordship)", "Rochau (lordship)", "Rohan-Soubise (principality)", "Rosen (lordship, county)", "Rosenbach (lordship)", "Rosenberg (lordship)", "Rosenthal (abbacy)", "Rotenhan (county)", "Rupertsberg und Eibingen (abbacy)", "Russia (kingdom)", "Saarwerden (county)", "Salis-Soglio (lordship)", "Salm-Dhaun (wild- and rhinegraviate)", "Salm-Kyrburg (principality)", "Salm-Kyrburg (wild- and rhinegraviate, principality)", "Salm-Kyrburg (wild- and rhinegraviate)", "Salm-Salm (principality)", "Salm-Salm (wild- and rhinegraviate, principality)", "Salm-Salm (wild- and rhinegraviate)", "Sargans (county)", "Saxe-Eisenach (duchy)", "Saxony (duchy)", "Saxe-Coburg-Saalfeld (duchy)", "Sayn (county)", "Sayn-Altenkirchen (county)", "Sayn-Hachenburg (county)", "Sayn-Wittgenstein (county)", "Sazenhofen (lordship)", "Scharfenberg (lordship)", "Schaumberg (county)", "Schaumburg (county)", "Schildeck (lordship)", "Schlaher (lordship)", "Schönberg (lordship)", "Schönborn (county)", "Schutzbar genannt Milchling [Burgmichling] (lordship)", "Schwäbisch Gmünd (imperial city)", "Schwarzenberg (barony)", "Schwarzenberg (county)", "Seckendorﬀ (lordship)", "Sickingen (county)", "Sickingen (lordship, county)", "Sickingen-Landstuhl (county)", "Sinsheim (lordship)", "Soest (imperial city)", "Solms (county)", "Spain (kingdom)", "Sparneck (lordship)", "Speyer (bishopric)", "Speyer (imperial city)", "Sponheim (county)", "Sponheim-Kreuznach (county)", "Sponheim-Starkenburg (county)", "St. Gallen (abbacy)", "St. John (order of chivalry)", "Belgium (kingdom)", "Stain (lordship)", "Steinach (lordship)", "Steinfurt (county)", "Stolberg-Königstein (county)", "Strahlenberg (lordship)", "Strasbourg (bishopric)", "Strasbourg (imperial city)", "Sweden (bailiwick)", "Sweden (kingdom)", "Sweden (principality)", "Swiss Confederacy (Eidgenossenschaft)", "Switzerland (republic)", "Syon (abbacy)", "Tänikon (abbacy)", "Tecklenburg (county)", "Tecklenburg-Lingen (country)", "Teutonic Order (imperial knights)", "Thun von Thunberg (lordship)", "Thüngen (lordship)", "Thurgau (canton)", "Tobel (commandry)", "Toggenburg (county)", "Tottenheim (lordship)", "Trier (electors, prince bishops)", "Truchseß von Baldersheim (lordship)", "United Provinces (confederation)", "Upper Palatinate (duchy)", "Valkenburg (county)", "Wisbeck (bailiwick)", "Veldenz (county)", "Venningen (lordship)", "Venningen-Eichtersheim (lordship)", "Vesternberg (lordship)", "Vintschgau (county)", "Vogelius (lordship)", "Vordere Sponheim (county)", "Waldeck (lordship)", "Walderdorf (lordship)", "Wallenstein (duchy)", "Warsberg (lordship)", "Wechmar 1559-1690", "Weinfelden (lordship)", "Weissenberg (lordship)", "Weissenburg (imperial city)", "Werth (lordship)", "Wertheim (county)", "Westphalia (kingdom)", "Wettingen (abbacy)", "Wetzlar (imperial city)", "Wevort (lordship)", "Wilhermsdorf (lordship)", "Wilnsdorf (lordship)", "Wimpfen (imperial city)", "Wiser (county)", "Wolfstein (lordship)", "Wolfsthal (county)", "Wolﬀ Metternich (lordship)", "Worms (bishopric)", "Worms (imperial city)", "Wörschweiler (abbacy)", "Württemberg (duchy)", "Württemberg (kingdom)", "Württemberg-Mömpelgard (duchy)", "Württemberg-Montbéliard (country, duchy)", "Würzburg (bishopric)", "Würzburg (grand duchy)", "Yrsch (lordship)", "Ysenburg-Bündingen (county)", "Żagań (duchy)", "Zeiskam (lordship)", "Ziegler (baliwick)", "Zillenhart (lordship)", "Zorn von Bulach (lordship)", "Zurich (canton)", "Zurich (imperial city)", "Zweibrücken-Bitsch (county)"]  
        // Uncomment below for Secular Ruler,  Early Modern only after confirming from Beth

        // const secularJuris = [ ...new Set( gJ.features.map((feature) => feature.properties["Secular Ruler,  Early Modern"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const bishop = [ ...new Set( gJ.features.map((feature) => feature.properties["Bishop (Early Modern)"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const archbishop = [ ...new Set( gJ.features.map((feature) => feature.properties["Archbishop (Early Modern)"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const churchName = [ ...new Set( gJ.features.map((feature) => feature.properties["Church Name (Modern)"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const typeSharing = [ ...new Set( gJ.features.map((feature) => feature.properties["church sharing type"]) 
                .filter(Boolean) // This removes falsy values like null, undefined, or empty strings
            ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const congregationsNum = [ ...new Set( gJ.features.map((feature) => feature.properties["Number of congregations"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const sharing = [ ...new Set( gJ.features.map((feature) => feature.properties["confessions (denominations) sharing church"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const protestants = [ ...new Set( gJ.features.map((feature) => feature.properties["Protestant Groups"]) ),].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const sharingStarted = [ ...new Set( gJ.features.map((feature) => feature.properties["Date sharing Started (de facto)"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const sharingEnded = [ ...new Set( gJ.features.map((feature) => feature.properties["Date sharing Ended (de facto)"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const groupInChurch = [ ...new Set( gJ.features.map((feature) => feature.properties["Group in church after dissolution of Simultaneum"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));

        const locationType = [ ...new Set( gJ.features.map((feature) => feature.properties["Location type (Early Modern)"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const rGroups = [ ...new Set( gJ.features.map((feature) => feature.properties["Continuing Denominations"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        const parishSaint = [ ...new Set( gJ.features.map((feature) => feature.properties["Parish Saint (historical)"]) ),]//.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
        
        // Below function works only when years are string
        const cleanAndSort = (arr) => {
            return Array.from(
                new Set(
                  arr
                    .map(item => item.trim()) // Remove extra spaces
                    .filter(item => /^\d+$/.test(item)) // Keep only valid year numbers
                )
              )
              .map(Number) // Convert to numbers
              .sort((a, b) => a - b) // Sort in ascending order
              .map(String); // Convert back to strings
        };

        // const cleanAndSort = (arr) => {
        //     return Array.from(new Set(arr)) // Remove duplicates
        //         .filter(item => Number.isInteger(item)) // Ensure only valid numbers remain
        //         .sort((a, b) => a - b); // Sort in ascending order
        // };
        

        let sortedDate = cleanAndSort(sharingStarted)
        let sortedDateEnd = cleanAndSort(sharingEnded)

        console.log(state.selectedLayer, " --- Date:: ", sortedDate)
        commit('SET_MODERNPLACE',modernPlacename) 
        commit('SET_DIST',district)  
        commit('SET_STATE',state_)  
        commit('SET_COUNTRY',country) 
        commit('SET_SECULAR',secularJuris) 
        commit('SET_BISHOP',bishop)  
        commit('SET_ARCHBISHOP',archbishop) 
        commit('SET_CHURCHNAME',churchName) 
        commit('SET_TYPESHARING',typeSharing) 
        commit('SET_CONGREGAT',congregationsNum) 
        commit('SET_SHARING',sharing) 
        commit('SET_PROTESTANT',protestants) 
        commit('SET_SHARINGST',sortedDate) 
        commit('SET_SHARINGEND',sortedDateEnd) 
        commit('SET_GROUPIN',groupInChurch) 

        commit('SET_LOC_TYPE',locationType) 
        commit('SET_RGROUPS',rGroups)
        commit('SET_PARISH_SAINT',parishSaint) 
      
      //   console.log("projectIds::", projectIds);
        // setMap(projectIds)
      },

    //   openDrawer({ commit }, content) {
    //     console.log("openDrawer::", openDrawer)
    //     commit('SET_DRAWER', { isOpen: true, content });
    //   },
    
 };

/** 
const state = { };
const getters = { };
const mutations = { };
const actions = { };
 */

export default {
    state,
    getters,
    mutations,
    actions
};